import PropTypes from 'prop-types';
import React, { Component } from 'react';


export default class FormGroup extends Component {
    static propTypes = {
        label: PropTypes.any,
        classNames: PropTypes.string,
        hasError: PropTypes.bool,
        fieldId: PropTypes.string,
        required: PropTypes.bool
    }

    render() {
        return (
            <div className={this.props.classNames + " form-group " + (this.props.hasError ? "invalid" : "")}>
                {this.props.label && (
                    <label htmlFor={this.props.fieldId} className={this.props.required ? "required-field-star" : ""}>
                        {this.props.label}
                    </label>
                )}
                <div className="field">
                    {this.props.children}
                </div>
                {this.props.hasError && <div className="validation-error">{this.props.hasError}</div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/FormGroup.jsx